module.exports = require("@swa-ui/core/src/SelectionMarker/SelectionMarker.module.scss");